
import axios from 'axios';
import ApiClient from './ApiClient';

const domainUrl = process.env.REACT_APP_API_BASE_URL;

// get Org by LocalStorage
export const getInfomationOrgLocalStorage = async (
  companyCode : string,
  specifyCode: string,
): Promise<Array<any>> => {
  const params = {
    specifyCode,
  };
  const response = await axios.get(`${domainUrl}/v2/whereami/${companyCode}`, {
    params,
    data: {},
  });
  return response.data;
};

// get current time
export const getCurrentTimeSystem = async (
): Promise<Array<any>> => {
  const params = {
  };
  const response = await axios.get(`${domainUrl}/v1/attendStamp/currentTime`, {
    params,
    data: {},
  });
  return response.data;
};

// get history recorder
export const getHistoryRecorder = async (
  companyCode: string,
  shopCode: string,
): Promise<Array<any>> => {
  const params = {
    orgCode: shopCode,
  };
  const response = await ApiClient.getNoAuth(shopCode, `/v1/attendStamp/history/${companyCode}`, params);

  return response.data;
};


// Recorder by Id
// export const handleRecorderById = async (companyCode: string,
//   data: any) => {
//   const params = data;
//   const response = await ApiClient.post(`v1/attendStamp/barcode/${companyCode}`, {}, params);
//   return response.data;
// };


export const handleRecorderById = async (
  shopCode: string,
  companyCode: string,
  data: any,
) : Promise<any> => {
  const response = await ApiClient.postMutipartDataNoAuth(`/v1/attendStamp/barcode/${companyCode}`, {}, data, shopCode);
  return response.data;
};

export const handleConfirmRecorder = async (
  shopCode: string,
  companyCode: string,
  data: any,
) : Promise<any> => {
  // れすだく用の打刻 API（v1 の打刻に加えて、移動時間を勤務時間とみなす処理をする。C3_RESDUC-1881）
  const response = await ApiClient.postMutipartDataNoAuth(`/v3/attendStamp/stamp/${companyCode}`, {}, data, shopCode);
  return response.data;
};

export const handleSubmitFaceImage = async (shopCode: string, companyCode: string, dataPost: any): Promise<any> => {
  // const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.postMutipartDataNoAuth(`/v1/attendStamp/${companyCode}`, {}, dataPost, shopCode);
  return response.data;
};


export default {
  getInfomationOrgLocalStorage,
};
